export default __webpack_public_path__ + "static/media/GRT-ETH.82518465.png";